<button mat-icon-button matTooltip="View all variations for this common item"
        (click)="openVariationsDialog()"
        aria-label="Open Variations Quick View">
    <mat-icon>visibility</mat-icon>
</button>
